import { CardContent, Typography } from "@material-ui/core";
import { memo } from "react";

const Empty = () => {
  return (
    <CardContent style={{ height: 352 }}>
      <Typography variant="body2">No results found</Typography>
    </CardContent>
  );
};

export default memo(Empty);
